import { isAdditional } from "./common";
export var filterExceededAdditionalAccumulators = function filterExceededAdditionalAccumulators() {
  var accumulators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return accumulators.filter(function (acc) {
    var rest = acc.rest,
      size = acc.size,
      baseRest = acc.baseRest;
    if (!isAdditional(acc) || acc !== null && acc !== void 0 && acc.isGiftBucket) {
      return true;
    }
    if (typeof baseRest === 'number') {
      return true;
    }
    return !(rest <= 0 || typeof size === 'number' && size < 0);
  });
};
export var getHasGiftAccumulator = function getHasGiftAccumulator() {
  var accumulators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return accumulators === null || accumulators === void 0 ? void 0 : accumulators.some(function (item) {
    return !!(item !== null && item !== void 0 && item.isGiftBucket);
  });
};